import { getActiveUser } from "@noom/hive-auth";
import { appConfig } from "src/config";
import { getAccessToken } from "src/utils/authCookieParser";

export function getAuthorizationHeader() {
  const userAccessToken = getActiveUser()?.accessToken ?? getAccessToken();
  const token = userAccessToken ?? appConfig.LOGGED_OUT_BUYFLOW_CLIENT_TOKEN;
  return { Authorization: `Bearer ${token}` };
}

export function getAnonymousClientAuthorizationHeader() {
  return {
    Authorization: `Bearer ${appConfig.LOGGED_OUT_BUYFLOW_CLIENT_TOKEN}`,
  };
}
